<mat-form-field class="w-100">
  <mat-label>{{_placeholder}}</mat-label>
  <input
    matInput
    [name]="id"
    [id]="id"
    type="text"
    [disabled]="_disabled"
    [ngModel]= "_value"
    (ngModelChange)="valueChanged($event)"
    [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete">
      @for (item of _filteredList; track $index) {
        <mat-option [value]="item.label">
          {{item.label}}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
